<template>
  <div class="message">
    <el-tabs v-model="msg_class">
      <el-tab-pane label="系统消息" name="1"></el-tab-pane>
      <el-tab-pane label="订单消息" name="2"></el-tab-pane>
      <el-tab-pane label="推送消息" name="3"></el-tab-pane>
    </el-tabs>
    <div class="main">
      <div class="msg_cell" v-for="i in msg_list" :key="i.msg_id">
        <div class="fr ac jsb mb10">
          <p>{{ i.msg_title }}</p>
          <p>{{ i.create_time }}</p>
        </div>
        <p class="fz12">{{ i.msg_desc }}</p>
      </div>
      <div class="fr ac jc">
        <el-pagination
            :hide-on-single-page="true"
            :current-page.sync="page"
            layout="prev, pager, next"
            :total="total"
            class="mt20 mb20"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      page: 1,
      total: 0,
      msg_list: [],
      msg_class: "1",
      active: "1"
    };
  },
  computed: {},
  created() {
    this.getMemberMsgs();
  },
  watch: {
    msg_class(n) {
      this.getMemberMsgs();
    },
    page(n) {
      this.getMemberMsgs();
    }
  },
  methods: {
    getMemberMsgs() {
      this.post("notification/getMemberMessageList", {
        page: this.page,
        msg_class: this.msg_class
      }).then(res => {
        this.msg_list = res.data;
        this.total = res.total;
      });
    }
  },
  components: {}
};
</script>

<style scoped lang="scss">
.message {
  font-size: 14px;

  .main {
    .msg_cell {
      width: 100%;
      padding: 20px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.16);
      opacity: 1;
      border-radius: 4px;
      margin-bottom: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/me/message/index.vue